import { AppstoreOutlined, DeploymentUnitOutlined, RocketOutlined, SettingOutlined, ShopOutlined, TeamOutlined } from "@ant-design/icons";
import type { CardProps } from "antd";
import { List, Typography } from "antd";
import i18n from "i18next";
import type { FC } from "react";
import { useNavigate } from "react-router";

import { DashboardCardContainer } from "src/app/features/Dashboard/utils/dashboardStyles";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";
import { Palette } from "../../../../core/styles/palette";

const { Text } = Typography;

interface QuickLink {
    icon: React.ReactNode;
    title: string;
    path: string;
    description: string;
}

interface QuickLinksCardProps extends CardProps {}

/**
 * QuickLinksCard - Quick navigation to common tasks
 */
export const QuickLinksCard: FC<QuickLinksCardProps> = ({ ...cardProps }) => {
    const navigate = useNavigate();

    const quickLinks: QuickLink[] = [
        {
            icon: <DeploymentUnitOutlined />,
            title: "menu.terminals",
            path: `${BASE_PATH}/${ResourceName.TERMINALS}`,
            description: "dashboard.quickLinks.terminals",
        },
        {
            icon: <RocketOutlined />,
            title: "menu.campaigns",
            path: `${BASE_PATH}/${ResourceName.CAMPAIGNS}`,
            description: "dashboard.quickLinks.campaigns",
        },
        {
            icon: <ShopOutlined />,
            title: "menu.sites",
            path: `${BASE_PATH}/${ResourceName.SITES}`,
            description: "dashboard.quickLinks.sites",
        },
        {
            icon: <AppstoreOutlined />,
            title: "menu.applicationsProfiles",
            path: `${BASE_PATH}/${ResourceName.APPLICATION_PROFILE_LISTS}`,
            description: "dashboard.quickLinks.applicationProfiles",
        },
        {
            icon: <TeamOutlined />,
            title: "menu.dataGroups",
            path: `${BASE_PATH}/${ResourceName.DATA_GROUPS}`,
            description: "dashboard.quickLinks.dataGroups",
        },
        {
            icon: <SettingOutlined />,
            title: "menu.configurationTransfer",
            path: `${BASE_PATH}/${ResourceName.CONFIGURATION_TRANSFER}`,
            description: "dashboard.quickLinks.configurationTransfer",
        },
    ];

    const handleNavigate = (path: string) => {
        navigate(path);
    };

    return (
        <DashboardCardContainer title={i18n.t("dashboard.quickLinks.title")} {...cardProps}>
            <List
                size="small"
                dataSource={quickLinks}
                renderItem={(item) => (
                    <List.Item style={{ cursor: "pointer", padding: "8px 0" }} onClick={() => handleNavigate(item.path)}>
                        <List.Item.Meta
                            avatar={
                                <div
                                    style={{
                                        fontSize: 18,
                                        color: Palette.HeroGreen,
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    {item.icon}
                                </div>
                            }
                            title={<Text strong>{i18n.t(item.title)}</Text>}
                            description={
                                <Text type="secondary" style={{ fontSize: 12 }}>
                                    {i18n.t(item.description)}
                                </Text>
                            }
                        />
                    </List.Item>
                )}
            />
        </DashboardCardContainer>
    );
};
